import { useMutation } from '@vue/apollo-composable';
import gql from 'graphql-tag';
import useAlerts from './useAlerts';

const { addAlert } = useAlerts();

const ADD_LEAD_MUTATION = gql`
  mutation AddLeadMutation($lead: TBL_LEADS_Input) {
    addLead(lead: $lead)
  }
`;

const UPDATE_LEAD_MUTATION = gql`
  mutation UpdateLeadMutation($leadid: ID!, $lead: TBL_LEADS_Input) {
    updateLead(LEADID: $leadid, lead: $lead)
  }
`;

const DELETE_LEAD_MUTATION = gql`
  mutation DeleteLeadMutation($leadid: ID!) {
    deleteLead(LEADID: $leadid)
  }
`;

export default function useLeadMutate() {
  const { mutate: addMutate } = useMutation(ADD_LEAD_MUTATION);
  const { mutate: updateMutate } = useMutation(UPDATE_LEAD_MUTATION);
  const { mutate: deleteMutate } = useMutation(DELETE_LEAD_MUTATION);

  async function addLead(lead) {
    try {
      const { data } = await addMutate({ lead });
      return data;
    } catch (error) {
      console.error('Error adding new lead:', error);
      addAlert('Error adding new lead', 'high', 4);
      return null;
    }
  }

  async function updateLead(leadid, lead) {
    try {
      const { data } = await updateMutate({ leadid, lead });
      return data;
    } catch (error) {
      console.error('Error updating lead:', error);
      addAlert('Error updating lead', 'high', 4);
      return null;
    }
  }

  async function deleteLead(leadid) {
    try {
      const { data } = await deleteMutate({ leadid });
      return data;
    } catch (error) {
      console.error('Error deleting lead:', error);
      addAlert('Error deleting lead', 'high', 4);
      return null;
    }
  }

  return {
    addLead,
    updateLead,
    deleteLead,
  };
}
